import { DateTime } from 'luxon';

import i18n from 'translations/i18n';

import Event from './Event';

import './EventList.scoped.scss';

interface Props {
  events: Array<any>;
}

const EventsList: React.FC<Props> = ({ events }) => {
  const getFormatedDate = date => {
    const dateISO = DateTime.fromISO(date);
    if (DateTime.now().diff(dateISO, 'days').get('days') > 1) {
      return dateISO.setLocale(i18n.language).toFormat('dd/MM/yyyy');
    }
    return dateISO.setLocale(i18n.language).toRelative();
  };

  return (
    <div className="wrapper">
      {events &&
        events.map(elem => {
          return (
            <Event name={elem.title} date={getFormatedDate(elem.created_at)} key={Math.random()} />
          );
        })}
    </div>
  );
};

export default EventsList;
